import { render, staticRenderFns } from "./labelDefineSon.vue?vue&type=template&id=00ac7380&scoped=true&"
import script from "./labelDefineSon.vue?vue&type=script&lang=js&"
export * from "./labelDefineSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac7380",
  null
  
)

export default component.exports